import React        from 'react';
import CSSModules   from 'react-css-modules';
import _            from 'underscore'

import style from './style.scss';

import Label            from '../Label';
import Input            from '../Input';
import TextArea         from '../TextArea';
import Button           from '../Button';
import DelegateList     from '../DelegateList';
import InputGroup       from '../InputGroup';
import InlineError      from '../InlineError';
import AccordionSection from '../AccordionSection';
import FancyCheckbox    from '../FancyCheckbox';

import * as paymentActions from '../../actions/payment';

import responseFormatter from '../../services/responseFormatter';
import paymentApi        from '../../services/payment';
import trimmer           from '../../services/trimmer';

import { reduxForm } from 'redux-form';
import {scrollToElementId} from "../../services/dom/elementScroller";

const DelegateActionPanel = (props) => {
    return (
        <div className={style['action-panel']}>
            {props.showCancelButton  &&
                <Button
                    className={style['action-button']}
                    type="button"
                    onClick={props.onCancelClick}
                >
                    <span>Cancel</span>
                </Button>
            }

            <Button
                type="submit"
                disabled={!props.isFormValid || props.isFormSubmitting || props.duplicateEmail}
                className={style['action-button']}
            >
                <span>Save</span>
            </Button>
        </div>
    )
};

class BookingDelegates extends React.Component {

    constructor() {

        super();

        this.state = {
            eLearningCourseId: null
        };
    }

    componentDidMount() {
        if (this.props.eLearningCourse) {
            this.props.fields.course_id.onChange(this.props.eLearningCourse.id);
            this.setState({eLearningCourseId: this.props.eLearningCourse.id});
            this._selectAllElearningUnits();
        }

        this._checkDuplicateAttendeeEmail = _.debounce(this._checkDuplicateAttendeeEmail, 300);
    }

    _selectAllElearningUnits() {
        const eLearningUnits = this.props.eLearningCourse.sorted_elearning_units
            .filter(u => u.type === 'module');
        this.props.fields.unit_ids.onChange(eLearningUnits.map(u => u.id));
        this.props.fields.units.onChange(eLearningUnits);
    }

    _getCurrentDelegateNumber() {

        if (this.props.delegateToEdit) {

            return this.props.delegateToEdit._index + 1;

        } else {

            return this.props.bookingValues.attendees.length + 1;
        }
    }

    _cancelDelegateForm() {
        this.props.resetForm();
        this.props.hideDelegateForm();
        scrollToElementId('delegates');
    }

    _validateDelegate(values, dispatch) {

        const isEditingDelegate = this.props.delegateToEdit;

        function validateSuccess() {

            if (isEditingDelegate) {

                dispatch(paymentActions.delegateEdited(values));

            } else {

                dispatch(paymentActions.delegateAdded(values));
            }

            scrollToElementId('delegates');
        }

        function validateFailed(response) {

            scrollToElementId('delegate-form');
            throw responseFormatter.apiErrorsToFormErrors(response.data.errors);
        }

        return paymentApi
            .validateDelegate(trimmer.trim({ ...values, is_elearning_delegate: !!this.state.eLearningCourseId }))
            .then(validateSuccess, validateFailed);
    }

    _toggleDelegateUnits(unit) {
        if (this.props.eLearningCourse && !this.props.eLearningCourse.overridden_price) {
            const { units, unit_ids } = this.props.fields;
            if (unit_ids.value.includes(unit.id)) {
                unit_ids.onChange(unit_ids.value.filter(id => id !== unit.id));
                units.onChange(units.value.filter(u => u.id !== unit.id));
            } else {
                unit_ids.onChange([...unit_ids.value, unit.id]);
                units.onChange([...units.value, unit]);
            }
        }
    }

    _checkDuplicateAttendeeEmail(emailText) {
        if(this.props.bookingValues.attendees.some(attendee => attendee.email === emailText)){
            this.props.setDuplicateAttendeeEmail(true);
        }else{
            this.props.setDuplicateAttendeeEmail(false);
        }
    }

    _getAddDelegateComponent() {

        const {
            fields: {
                first_name,
                last_name,
                job_title,
                email,
                phone,
                requirements,
                unit_ids
            },
            valid,
            submitting,
            handleSubmit
        } = this.props;

        return (
            <div>
                <form id="delegate-form" onSubmit={ handleSubmit(this._validateDelegate.bind(this)) }>
                    <AccordionSection>
                        <h3 className={style['delegate-section-title']}>
                            Delegate { this._getCurrentDelegateNumber() }
                        </h3>

                        <div className={style['form-input-container']}>
                            <InputGroup>
                                <Label isRequired="true">
                                    First Name
                                </Label>
                                <Input { ...first_name } errors={ first_name.error } />
                                <InlineError errors={ first_name.error } />
                            </InputGroup>

                            <InputGroup>
                                <Label  isRequired="true">Last Name</Label>
                                <Input { ...last_name } errors={ last_name.error } />
                                <InlineError errors={ last_name.error } />
                            </InputGroup>

                            <InputGroup>
                                <Label isRequired="true">Job Title</Label>
                                <Input { ...job_title } errors={ job_title.error } />
                                <InlineError errors={ job_title.error } />
                            </InputGroup>

                            <InputGroup>
                                <Label isRequired="true">Email</Label>
                                <Input { ...email } type="email" errors={ email.error } onKeyUp={e => this._checkDuplicateAttendeeEmail(e.target.value)} />
                                <InlineError errors={ email.error } />
                                {this.props.duplicateAttendeeEmail && <InlineError errors={{errorContainer: ["This email address has already been entered"]}} />}

                            </InputGroup>

                            <InputGroup>
                                <Label isRequired="true">Telephone</Label>
                                <Input { ...phone } type="tel" errors={ phone.error } />
                                <InlineError errors={ phone.error } />
                            </InputGroup>

                            {!this.state.eLearningCourseId &&
                                <InputGroup className={style['special-requirements']}>
                                    <Label>Special Requirements</Label>
                                    <TextArea {...requirements} errors={requirements.error}/>
                                    <InlineError errors={requirements.error}/>
                                </InputGroup>
                            }

                            <span className={style['required-fields-instruction']}>* Compulsory Fields</span>
                        </div>

                        {(!this.state.eLearningCourseId || this.props.eLearningCourse.sorted_elearning_units.length === 0) &&
                            <DelegateActionPanel
                                showCancelButton={this.props.bookingValues.attendees.length > 0}
                                onCancelClick={this._cancelDelegateForm.bind(this)}
                                isFormValid={valid}
                                isFormSubmitting={submitting}
                                duplicateEmail={this.props.duplicateAttendeeEmail}
                            />
                        }
                    </AccordionSection>

                    {this.state.eLearningCourseId && this.props.eLearningCourse.sorted_elearning_units.length > 0 &&
                        <AccordionSection>
                            <h3 className={style['delegate-section-title']}>
                                Module Selection
                            </h3>

                            {this.props.eLearningCourse && this.props.eLearningCourse.overridden_price &&
                                <p className={style['compulsory-modules-message']}>All modules are compulsory for this course.</p>
                            }

                            <div className={style['module-choice-table-container']}>
                                <table className={style['module-choice-table']}>
                                    <tbody>
                                    {this.props.eLearningCourse.sorted_elearning_units.filter(u => u.type === 'module').map((unit, i) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <FancyCheckbox
                                                        type="checkbox"
                                                        id={'checkbox_' + i}
                                                        onClick={() => this._toggleDelegateUnits(unit)}
                                                        checked={unit_ids.value.includes(unit.id)}
                                                    />
                                                </td>
                                                <td><span className={unit_ids.value.includes(unit.id) ? '' : style['unit-title--unselected']}>{unit.title.split(':')[0].trim()}</span></td>
                                                <td><span className={unit_ids.value.includes(unit.id) ? '' : style['unit-title--unselected']}>{unit.title.split(':')[1].trim()}</span></td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>
                            </div>

                            <InlineError errors={ unit_ids.error } />

                            {this.state.eLearningCourseId &&
                                <DelegateActionPanel
                                    showCancelButton={this.props.bookingValues.attendees.length > 0}
                                    onCancelClick={this._cancelDelegateForm.bind(this)}
                                    isFormValid={valid}
                                    isFormSubmitting={submitting}
                                    duplicateEmail={this.props.duplicateAttendeeEmail}
                                />
                            }
                        </AccordionSection>
                    }
                </form>
            </div>
        );
    }

    _showNewDelegateForm() {

        this.props.initializeForm({});

        if (this.state.eLearningCourseId) {
            this.props.fields.course_id.onChange(this.state.eLearningCourseId);
            this._selectAllElearningUnits();
        }

        this.props.showNewDelegateForm();
    }

    _editDelegate(delegate) {

        this.props.initializeForm(delegate);

        if (this.state.eLearningCourseId) {
            this.props.fields.course_id.onChange(this.state.eLearningCourseId);
        }

        this.props.editDelegate(delegate);
    }

    _removeDelegate(delegateIndex) {

        this.props.initializeForm({});
        this.props.removeDelegate(delegateIndex);
    }

    render() {

        return (
            <div>

                <DelegateList
                    delegates={ this.props.bookingValues.attendees }
                    editDelegate={ this._editDelegate.bind(this) }
                    removeDelegate={ this._removeDelegate.bind(this) }
                    editable={ true }
                    small={ false }
                />

                {!this.props.isShowingDelegateList && this._getAddDelegateComponent()}
                
                {this.props.isShowingDelegateList &&
                    <div>
                        <AccordionSection>
                            <div className={style['button-container']}>
                                <Button styleName="new-delegate-button"
                                        type="button"
                                        onClick={ this._showNewDelegateForm.bind(this) }>

                                    <span>Add delegate</span>

                                </Button>
                            </div>
                        </AccordionSection>

                        <AccordionSection>
                            <div className={style['button-container']}>
                                <Button onClick={ this.props.backToOrganisation }
                                        styleName="back-button"
                                        type="button">
                                    <span>Back</span>
                                </Button>
                                <Button onClick={ this.props.proceedToPayment }
                                        styleName="proceed-button"
                                        type="button">
                                    <span>Next</span>
                                </Button>
                            </div>
                        </AccordionSection>
                    </div>
                }

            </div>
        );
    }
}

function mapStateToProps(state) {

    return state.payment;
}

function mapDispatchToProps(dispatch) {

    return {
        delegateEdited(delegate, delegateIndex) {

            dispatch(paymentActions.delegateEdited(delegate, delegateIndex));
        },
        editDelegate(delegate) {

            dispatch(paymentActions.editDelegate(delegate));
        },
        removeDelegate(delegateIndex) {

            dispatch(paymentActions.removeDelegate(delegateIndex));
        },
        proceedToPayment() {

            dispatch(paymentActions.proceedToPayment());
            setTimeout(() => {
                scrollToElementId('payment');
            }, 0);
        },
        hideDelegateForm() {

            dispatch(paymentActions.hideDelegateForm());
        },
        backToOrganisation() {
            
            dispatch(paymentActions.backToOrganisation());
            scrollToElementId('organisation');
        },
        showNewDelegateForm() {

            dispatch(paymentActions.showNewDelegateForm());
        },

        setDuplicateAttendeeEmail(isDuplicate) {

            dispatch(paymentActions.setDuplicateAttendeeEmail(isDuplicate));
        }
    }
}

const formParams = {
    form: 'booking-delegates',
    fields: [
        '_index',
        'first_name',
        'last_name',
        'job_title',
        'email',
        'phone',
        'requirements',
        'course_id',
        'unit_ids',
        'units'
    ]
};

export default reduxForm(formParams, mapStateToProps, mapDispatchToProps)(CSSModules(BookingDelegates, style));


// WEBPACK FOOTER //
// ./components/BookingDelegates/index.js